
export default {
    name: 'Error500',
    methods: {
        tryAgain() {
            location.reload();
        },
    },
};
